import * as React from "react";
import {assets} from "../../helpers";

export class PressConference extends React.Component<any, any> {
    render() {
        return (
            <section className="press">
                <a name="press" />
                <ul>
                    <li>
                        <div className="media">
                            <div className="media-left"><a
                                href="http://personalaudio.ru/detail/unikalnaya_vstrecha_lyubiteley_personalnogo_audio_v_moskve/"
                                target="_blank"><img src={assets("press/ixbt.jpg")} /></a></div>
                            <div className="media-body"><a
                                href="http://personalaudio.ru/detail/unikalnaya_vstrecha_lyubiteley_personalnogo_audio_v_moskve/"
                                target="_blank" className="pressName">IXBT.COM</a><a
                                href="http://personalaudio.ru/detail/unikalnaya_vstrecha_lyubiteley_personalnogo_audio_v_moskve/"
                                target="_blank"><span>Уникальная встреча любителей персонального аудио в Москве!</span></a>
                                <p>
                                    Это было великолепное сочетание  невероятно дружелюбной атмосферы самых простых людей и сложной техники. Loudhead, пожалуй лучшее событие в этом году для всех настоящих ценителей хорошего звука.</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="media">
                            <div className="media-left"><a href="http://www.hi-fi.ru/news/dom/detail/1009490"
                                                       target="_blank"><img src={assets("press/2.png")} /></a></div>
                            <div className="media-body"><a href="http://www.hi-fi.ru/news/dom/detail/1009490"
                                                       target="_blank" className="pressName">Hi-Fi.ru</a><a
                                href="http://www.hi-fi.ru/news/dom/detail/1009490" target="_blank"><span>Doctorhead: персональное аудио в Москве</span></a>
                                <p>
                                    Для нашей страны это абсолютно новый формат, которому организаторы Loudhead смогли придать свой особенный шарм, выражавшийся в необыкновенно дружелюбной атмосфере при огромном количестве гостей на один квадратный метр.</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="media">
                            <div className="media-left"><a href="http://www.salonav.com/arch/2014/12/loudhead.htm"
                                                       target="_blank"><img src={assets("press/3.png")} /></a></div>
                            <div className="media-body"><a href="http://www.salonav.com/arch/2014/12/loudhead.htm"
                                                       target="_blank" className="pressName">AudioVideo</a><a
                                href="http://www.salonav.com/arch/2014/12/loudhead.htm" target="_blank"><span>НАЕДИНЕ, НО ВМЕСТЕ</span></a>
                                <p>
                                    «Будем надеяться, что встречи «Loudhead» станут регулярными, а число их участников будет расти – потребность в таком общении огромна, особенно в наши нелёгкие времена...»<br />Дмитрий Ловковский
                                </p></div>
                        </div>
                    </li>
                    <li>
                        <div className="media">
                            <div className="media-left"><a href="http://www.hifinews.ru/article/details/24677.htm"
                                                       target="_blank"><img src={assets("press/4.png")} /></a></div>
                            <div className="media-body"><a href="http://www.hifinews.ru/article/details/24677.htm"
                                                       target="_blank" className="pressName">hifiNews</a><a
                                href="http://www.hifinews.ru/article/details/24677.htm" target="_blank"><span>Уникальная встреча в Москве!</span></a>
                                <p>
                                    Заходя в наполненный людьми с горящими глазами зал, словно отключался от реальности серой Москвы за дверями выставочного павильона и попадал в рай для аудиофила.</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="media">
                            <div className="media-left"><a
                                href="http://nota.ru/news/loudhead_2014_vstrecha_lyubiteley_personalnogo_audio/"
                                target="_blank"><img src={assets("press/5.png")} /></a></div>
                            <div className="media-body"><a
                                href="http://nota.ru/news/loudhead_2014_vstrecha_lyubiteley_personalnogo_audio/"
                                target="_blank" className="pressName">Нота Плюс</a><a
                                href="http://nota.ru/news/loudhead_2014_vstrecha_lyubiteley_personalnogo_audio/"
                                target="_blank"><span>Благодарим организаторов и всех любителей качественного аудио</span></a>
                                <p>
                                    Это одна из самых интересных и насыщенных встреч года по данной тематике!Ну и конечно все участники мероприятия и посетители смогли насладиться качественной музыкой, пообщаться со своими единомышленниками и партнерами, ощутить дух товарищества и поддержку сотен таких же аудио-вундеркиндов как они сами за пинтой приятного эля!  Владислав Шабельский "Нота Плюс"</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </section>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Main/PressConference.tsx
 **/